<template>
  <div class="form-container position-absolute top-50 start-50 translate-middle">
    <div class="bb-outer-area">
      <div class="auth-box text-center">
        <img class="mt-4 mb-3" src="/bbLogo32Blue.png" alt="logo" />
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="profileChange">
          <!-- -------------- -->
          <!--     avatar     -->
          <!-- -------------- -->
          <div class="form-group">
            <div class="form-floating mt-3 mb-2">
              <img v-bind:src="avatar_image" height="150" width="150" class="rounded-circle bb-img" alt="Avatar" />
            </div>
            <!-- ------------------- -->
            <!--   image selection   -->
            <!-- ------------------- -->
            <label class="btn btn-dark btn-file mb-2">
              Upload Image
              <input type="file" accept="image/*" style="display: none"
                class="img-fluid rounded-circle border border-dark bb-image-container" id="selectImage" />
            </label>
          </div>
          <!-- -------------- -->
          <!--   first name   -->
          <!-- -------------- -->
          <div class="form-group">
            <div class="form-floating mt-3 mb-3">
              <input v-model="first_name" id="first_name" placeholder="first name" type="text"
                class="form-control capitalize" autocomplete="off" required />
              <label class="bb-float-label" for="first_name">First Name</label>
            </div>
          </div>
          <!-- -------------- -->
          <!--   last name   -->
          <!-- -------------- -->
          <div class="form-group">
            <div class="form-floating mt-3 mb-3">
              <input v-model="last_name" id="last_name" placeholder="last name" type="text"
                class="form-control capitalize" autocomplete="off" required />
              <label class="bb-float-label" for="last_name">Last Name</label>
            </div>
          </div>
          <!-- -------------- -->
          <!--   user name    -->
          <!-- -------------- -->
          <div class="form-group">
            <div class="form-floating mt-3 mb-3">
              <input v-model="user_name" id="user_name" placeholder="user name" type="text"
                class="form-control capitalize" autocomplete="off" required />
              <label class="bb-float-label" for="user_name">User Name</label>
            </div>
          </div>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div v-for="err in errors" :key="err.id" class="bb-error mt-2">
            {{ err }}
          </div>
          <!-- ------------ -->
          <!--  button row  -->
          <!-- ------------ -->
          <div class="row mt-4 mb-3">
            <!-- ------------ -->
            <!--    buttons   -->
            <!-- ------------ -->
            <div class="btn-group special mt-3 mb-2" role="group">
              <!-- ------------ -->
              <!--    cancel    -->
              <!-- ------------ -->
              <button @click="$router.go(-1)" class="btn btn-lg btn-warning">Cancel</button>
              <!-- ------------ -->
              <!--      OK      -->
              <!-- ------------ -->
              <button type="submit" :disabled="!isProfileChanged && !isAvatarChanged" class="btn btn-lg btn-primary">
                OK
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'editProfileView',
  data() {
    return {
      id: 0,
      email: '',
      first_name: '',
      last_name: '',
      user_name: '',
      avatar_image: null,
      avatar_file: null,
      errors: [],
      isProfileUpdateCall: false,
      isAvatarUpdateCall: false,
      isProfileUpdated: false,
      isAvatarUpdated: false,
    }
  },
  //----------------------
  // computed values
  //----------------------
  computed: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
    }),
    isProfileChanged() {
      if (
        this.getUserProfile.first_name != this.first_name ||
        this.getUserProfile.last_name != this.last_name ||
        this.getUserProfile.user_name != this.user_name
      ) {
        if (this.first_name && this.last_name && this.user_name) {
          return true
        }
      }
      return false
    },
    isAvatarChanged() {
      if (this.getUserProfile.avatar_image != this.avatar_image) {
        return true
      }
      return false
    },
    isReadProfileReady() {
      if (this.isProfileUpdateCall && this.isAvatarUpdateCall) {
        if (this.isProfileUpdated && this.isAvatarUpdated) {
          return true
        }
      } else if (this.isProfileUpdateCall && this.isProfileUpdated) {
        return true
      } else if (this.isAvatarUpdateCall && this.isAvatarUpdated) {
        return true
      }
      return false
    },
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapMutations('auth', {
      setCurrentView: 'setCurrentView',
    }),
    ...mapActions('auth', {
      editUserProfile: 'editUserProfile',
      readUserProfile: 'readUserProfile',
      changeAvatar: 'changeAvatar',
    }),
    setView(view) {
      this.setCurrentView(view)
    },
    //-------------------------
    // change profile method
    //-------------------------
    async profileChange() {
      this.errors = []
      const payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        user_name: this.user_name,
      }
      //-------------------------------
      // where profile details changed
      //-------------------------------
      if (this.isProfileChanged) {
        this.isProfileUpdateCall = true
        //----------------------
        // api call
        //----------------------
        await this.editUserProfile({ payload })
          //-----------------------------------
          // where successful (force re-logon)
          //-----------------------------------
          .then(() => {
            this.isProfileUpdated = true
          })
          //----------------------
          // where error
          //----------------------
          .catch((err) => {
            this.errors = window.loadResponseErrors(err.response.data)
          })
      }
      //----------------------
      // where avatar changed
      //----------------------
      if (this.isAvatarChanged) {
        const avatar_file = this.avatar_file
        this.isAvatarUpdateCall = true
        //----------------------
        // api call
        //----------------------
        await this.changeAvatar({ avatar_file })
          //-----------------------------------
          // where successful (force re-logon)
          //-----------------------------------
          .then(() => {
            this.isAvatarUpdated = true
          })
          //----------------------
          // where error
          //----------------------
          .catch((err) => {
            if (err.response) {
              this.errors = window.loadResponseErrors(err.response.data)
            }
          })
      }
      //----------------------------------------------------
      // where profile/avatar been updated - reread profile
      //----------------------------------------------------
      if (this.isReadProfileReady) {
        //----------------------
        // api call
        //----------------------
        await this.readUserProfile({ payload })
          //----------------------
          // where successful
          //----------------------
          .then(() => {
            this.$router.push({ name: 'campaignsView' })
          })
          //----------------------
          // where error
          //----------------------
          .catch((err) => {
            if (err.response) {
              this.errors = window.loadResponseErrors(err.response.data)
            }
          })
      }
    },
  },
  //-------------------------
  // mounted
  //-------------------------
  mounted() {
    //------------------
    // set partial view
    //------------------
    this.setView('partial')
    //-------------------------
    // avatar image selection
    //-------------------------
    var fileInput = document.getElementById('selectImage')
    //-------------------------
    // display new image
    //-------------------------
    const preview = async (event) => {
      const file = event.target.files[0]
      const url = await readURL(file)
      this.avatar_image = url
      // create avatar file for uploading
      const formData = new FormData()
      formData.append('avatar_image', file)
      this.avatar_file = formData
    }
    //-----------------------------
    // convert file to a base64 url
    //------------------------------
    const readURL = (file) => {
      return new Promise((res, rej) => {
        const reader = new FileReader()
        reader.onload = (e) => res(e.target.result)
        reader.onerror = (e) => rej(e)
        reader.readAsDataURL(file)
      })
    }
    //-------------------------
    // avatar image selection
    //-------------------------
    fileInput.addEventListener('change', preview)
    //-------------------------
    // set bg color
    //-------------------------
    document.body.className = 'bb-bg-partial'
    //------------------------------
    // load existing profile values
    //------------------------------
    this.id = this.getUserProfile.id
    this.email = this.getUserProfile.email
    this.first_name = this.getUserProfile.first_name
    this.last_name = this.getUserProfile.last_name
    this.user_name = this.getUserProfile.user_name
    this.avatar_image = this.getUserProfile.avatar_image
  },
  unmounted() {
    document.body.className = 'bb-bg-full'
    //----------
    // set view
    //----------
    this.setView('campaigns')
  },
}
</script>